import React, { useEffect, useState } from "react";
import {
    makeStyles,
    TableContainer,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Table,
    withStyles,
    Typography,
    Box
} from "@material-ui/core";
import CallIcon from '@mui/icons-material/Call';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import Avatar from '@mui/material/Avatar';
import { fontSize, fontWeight, textAlign } from "@mui/system";
import { RemoveRedEye } from "@material-ui/icons";
import encSecret from "../../config/encryption";
import { Button } from "@mui/material";
import GavelIcon from '@mui/icons-material/Gavel';

var CryptoJS = require("crypto-js");


const useStyles = makeStyles((theme) => ({
    root: {
        width: "100%",
        marginTop: theme.spacing(3)
    },
    head: {
        backgroundColor: "#fff",
        minWidth: "50px"
    },
    tableContainer: {
        backgroundColor: "#fff",
    },
    cell: {
        minWidth: "50px",

    }
}));

const StickyTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        width: "170px",
        display: "block",
        justifyContent: "space-between",
        position: "sticky",
        left: 0,
        // position: "-webkit - sticky",
        // position: "-moz - sticky",
        // position: "-o - sticky",
        // position: "-ms - sticky",
        zIndex: theme.zIndex.appBar + 2
    },
    body: {
        // backgroundColor: "#ddd",
        backgroundColor: "#fff",
        width: "170px",
        display: "block",
        justifyContent: "space-between",
        position: "sticky",
        top: 0,
        left: 0,
        // position: "-webkit - sticky",
        // position: "-moz - sticky",
        // position: "-o - sticky",
        // position: "-ms - sticky",
        zIndex: theme.zIndex.appBar + 1
    }
}))(TableCell);

const StyledTableCell = withStyles((theme) => ({
    head: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.common.black,
        fontWeight: 600,
        fontSize: 15,
        textAlign: "center"
    },
    body: {
        fontSize: 12,
        textAlign: "center"
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        "&:nth-of-type(odd)": {
            backgroundColor: theme.palette.action.hover
        }
    }
}))(TableRow);


const TableDash = (props) => {

    console.log("::: ", props);

    const [clients, setClients] = useState(props.clients);
    const dateRange = props.dateRange;
    const classes = useStyles();


    return (

        <>
            <Box style={{ padding: "5px 0px 5px 0px" }}>
                <TableContainer>
                    <Table style={{ minWidth: 510 }} aria-label="customized table">
                        <TableBody>

                            <StyledTableRow>
                                <StyledTableCell>
                                    <Button variant="outlined" color="success" style={{ borderRadius: 20, fontSize: 12 }}>0 deals today (4)</Button>
                                </StyledTableCell>
                                <StyledTableCell>
                                    <Button variant="outlined" color="secondary" style={{ borderRadius: 20, fontSize: 12 }}>0 views today (5)</Button>
                                </StyledTableCell>
                                <StyledTableCell>
                                    <Button variant="outlined" color="success" style={{ borderRadius: 20, fontSize: 12 }}>Didn't login</Button>
                                </StyledTableCell>
                            </StyledTableRow>

                        </TableBody>
                    </Table>
                </TableContainer>

            </Box>
            <Box style={{ padding: "5px 0px 5px 0px" }}>
                <TableContainer className={classes.tableContainer}>
                    <Table stickyHeader aria-label="sticky table" style={{ margin: '0px' }}>
                        <TableHead>
                            <TableRow>
                                <StickyTableCell className={classes.head} style={{ padding: 0 }}>
                                    <StyledTableCell className={classes.head} numeric>
                                        Name
                                    </StyledTableCell>

                                </StickyTableCell>
                                <StyledTableCell className={classes.head} numeric>
                                    Contact
                                </StyledTableCell>
                                {
                                    (dateRange && dateRange.map((date, index) =>
                                        <StyledTableCell key={date} className={classes.head} numeric>
                                            {date}
                                        </StyledTableCell>
                                    ))
                                }
                            </TableRow>
                        </TableHead>
                        <TableBody>

                            {
                                (clients && clients.map((client) =>
                                    // console.log("CCC ::: ", client);
                                    <StyledTableRow key={client}>
                                        <StickyTableCell style={{ padding: 3 }}>
                                            <StyledTableCell
                                                numeric
                                                align="left"
                                                className={classes.cell}

                                            >
                                                <Box style={{ display: 'flex', textAlign: 'left', height: 100, alignItems: 'center', justifyContent: 'center' }}>
                                                    <Box mr={1}>
                                                        <Avatar alt="Remy Sharp" src={client.img} />
                                                    </Box>
                                                    <Typography variant="body1" style={{ fontWeight: 500 }}>
                                                        {CryptoJS.AES.decrypt(client.Name, encSecret.key).toString(CryptoJS.enc.Utf8)}<br />
                                                        <span style={{ fontSize: 12 }}>{client.City}</span>
                                                    </Typography>
                                                </Box>

                                            </StyledTableCell>
                                        </StickyTableCell>
                                        <StyledTableCell>
                                            <span style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                <a href={"tel:" + client.PhoneNo}><CallIcon /></a>
                                                <a href={"https://wa.me/91" + client.PhoneNo}><WhatsAppIcon style={{ color: 'green' }} /></a>

                                            </span>
                                        </StyledTableCell>
                                        {
                                            (dateRange && dateRange.map((date, index) =>
                                                <StyledTableCell key={date + index} className={classes.head} numeric>
                                                    <table>
                                                        <thead>
                                                            <tr>
                                                                <th colSpan={4} style={{ fontSize: 20 }}>{client.dealsSummarize && client.dealsSummarize[date] ? client.dealsSummarize[date].deals : 0}</th>
                                                            </tr>
                                                            <tr style={{ fontSize: 16 }}>
                                                                <th>{(client && client.dealsSummarize && client.dealsSummarize[date]) ? client.dealsSummarize[date].views : 0}</th>
                                                                <th>{(client && client.dealsSummarize && client.dealsSummarize[date]) ? client.dealsSummarize[date].phone : 0}</th>
                                                                <th>{(client && client.dealsSummarize && client.dealsSummarize[date]) ? client.dealsSummarize[date].whatsapp : 0}</th>
                                                                <th>{(client && client.dealsSummarize && client.dealsSummarize[date]) ? client.dealsSummarize[date].suggest : 0}</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td>
                                                                    <RemoveRedEye />
                                                                </td>
                                                                <td>
                                                                    <CallIcon />
                                                                </td>
                                                                <td>
                                                                    <WhatsAppIcon />
                                                                </td>
                                                                <td>
                                                                    <GavelIcon/>
                                                                </td>
                                                            </tr>
                                                        </tbody>

                                                    </table>
                                                </StyledTableCell>
                                            ))
                                        }

                                    </StyledTableRow>

                                ))
                            }
                            {/* {(clients && clients.map((n, index) =>             
                                // <StyledTableRow key={n.PhoneNo}>
                                //     <StickyTableCell style={{ padding: 0 }}>
                                //         <StyledTableCell
                                //             numeric
                                //             align="left"
                                //             className={classes.cell}

                                //         >
                                //             <Box style={{ display: 'flex', textAlign: 'left' }}>
                                //                 <Box mr={1}>
                                //                     <Avatar alt="Remy Sharp" src={""} />
                                //                 </Box>
                                //                 <Typography variant="body1" style={{ fontWeight: 500 }}>
                                //                     {n.Name}<br />
                                //                     <span style={{ fontSize: 12 }}>{n.City}</span>
                                //                 </Typography>
                                //             </Box>

                                //         </StyledTableCell>

                                //     </StickyTableCell>
                                //     <StyledTableCell
                                //         align="center"
                                //         className={classes.cell}
                                //         style={{ width: "90px" }}
                                //     >
                                //         <span style={{ display: 'flex', justifyContent: 'space-between' }}>
                                //             <CallIcon />
                                //             <WhatsAppIcon style={{ color: 'green' }} />
                                //         </span>

                                //     </StyledTableCell>
                                //     <StyledTableCell
                                //         numeric
                                //         align="center"
                                //         className={classes.cell}
                                //     >
                                //         <table>
                                //             <tr>
                                //                 <th>17</th>
                                //                 <th>5</th>
                                //                 <th>4</th>
                                //             </tr>
                                //             <tr>
                                //                 <td>
                                //                     <RemoveRedEye />
                                //                 </td>
                                //                 <td>
                                //                     <CallIcon />
                                //                 </td>
                                //                 <td>
                                //                     <WhatsAppIcon />
                                //                 </td>
                                //             </tr>
                                //         </table>
                                //     </StyledTableCell>
                                //     <StyledTableCell
                                //         numeric
                                //         align="center"
                                //         className={classes.cell}
                                //     >
                                //         0
                                //     </StyledTableCell>
                                //     <StyledTableCell
                                //         numeric
                                //         align="center"
                                //         className={classes.cell}
                                //     >
                                //         0
                                //     </StyledTableCell>
                                //     <StyledTableCell
                                //         numeric
                                //         align="center"
                                //         className={classes.cell}
                                //     >
                                //         0
                                //     </StyledTableCell>
                                //     <StyledTableCell
                                //         numeric
                                //         align="center"
                                //         className={classes.cell}
                                //     >
                                //         0
                                //     </StyledTableCell>
                                //     <StyledTableCell
                                //         numeric
                                //         align="center"
                                //         className={classes.cell}
                                //     >
                                //         0
                                //     </StyledTableCell>
                                //     <StyledTableCell
                                //         numeric
                                //         align="center"
                                //         className={classes.cell}
                                //     >
                                //         0
                                //     </StyledTableCell>
                                //     <StyledTableCell
                                //         numeric
                                //         align="center"
                                //         className={classes.cell}
                                //     >
                                //         0
                                //     </StyledTableCell>
                                // </StyledTableRow>  
                                {
                                    console.log(n);
                                }
                                                   
                        ))} */}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </>
    );
};

export default TableDash;